import { EnumPersonaFisicaRequestDTORuolo } from '@framework/api-client/api/backoffice/schemas/enumPersonaFisicaRequestDTORuolo.ts';
import { type PersonaFisicaRequestDTO } from '@framework/api-client/api/backoffice/schemas/personaFisicaRequestDTO.ts';
import { yup } from '@framework/validation/initYup.ts';

export const DossierPermissionRequestSchema = yup
  .object({
    id: yup.string().notRequired(),
    nome: yup.string().required(),
    cognome: yup.string().required(),
    email: yup.string().email().notRequired(), // TODO
    pec: yup.string().email().notRequired(), // TODO
    codiceFiscale: yup.string().required(),
    ruolo: yup.string().oneOfEnum(EnumPersonaFisicaRequestDTORuolo).required(),
  })
  .required()
  .noUnknown() satisfies yup.ObjectSchema<PersonaFisicaRequestDTO>;

export type IDossierPermissionRequest = yup.InferType<
  typeof DossierPermissionRequestSchema
>;
